























































































import authentication from '@/configuration/authentication';
import { PageName } from '@/configuration/pages';
import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class MenuBody extends Vue {

    public isProductManagementFeatureEnabled: boolean = (window as any).config ? (window as any).config.isProductManagementFeatureEnabled : false;
    public appVersion: string = process.env.VUE_APP_VERSION || '';

    onClose() {
        this.$emit('onClose');
    }

    onRedirect(pageName: PageName) {
        this.$emit('onRedirect', pageName);
    }

    onLogout() {
        this.$emit('onLogout');
    }

    canAccess(pageName: PageName) {
        return authentication.canAccess(pageName);
    }
}
